import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./Pressrelease.css";
import { Link } from "react-router-dom";
import { pressReleases } from "./data";
import { useState } from "react";

const NewPR = () => {
  const [showAll, setShowAll] = useState(false);

  // Slice first 9 or show all
  const visiblePressReleases = showAll
    ? pressReleases
    : pressReleases.slice(0, 9);

  return (
    <>
      <NewHead />

      <Helmet>
        <title>Beleaf Press release</title>

        <meta name="title" content="Press release" />
        <meta
          name="description"
          content="Develop your tokenized diamond with beleaf technologies exclusive development service. Consult with our experts."
        />

        <meta property="og:title" content="Press release" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/pressrelease"
        />
      </Helmet>

      <main className="press-release-main press_release_wrap">
        <article className="primary__landing__container">
          <div className="pr_hd_link_wrap"> 
            <Link to="/" className="pr_hd_link_lft">
              <span>
                <i className="fa-solid fa-arrow-left"></i>{" "}
              </span>
              Home
            </Link>
            <span className="pr_slash">/</span>
            <Link className="pr_hd_link_rgt">Press release</Link>
          </div>
        </article>

        {/* hero */}
        <article className="primary__landing__container">
          <div className="pr-re-hero">
            <div className="row pr-rel-row">
              <div className="col-md-7">
                <h1 className="pr_rel_tp_title pr_cryp_dr_title">
                  Diamond Tokenization Development
                </h1>
                <p className="pr_rel_tp_content">
                  Build a Secure Diamond Tokenization Platform with beleaf
                    technologies
                </p>
                <Link
                  to="/diamond-tokenization-development"
                  className="pr_rel_tp_link"
                >
                  Read More{" "}
                  <span>
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </Link>
              </div>
              <div className="col-md-5">
                <img
                  src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776763480/DiamondTokenizationDevelopment_squwul.webp"
                  alt="Diamond Tokenization Development"
                  className="pr-rel-img"
                />
              </div>
            </div>
          </div>
        </article>

        <article className="pressrelease-blog-wrapper">
          <div className="primary__landing__container">
            {/* <div className="row g-xl-5 g-4">
              {pressReleases.map((item, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <Link to={item.link} className="pr_rel_outer">
                    <div className="pressrelease-card">
                      <Link to={item.link}>
                        <img
                          src={item.imgSrc}
                          alt={item.alt}
                          className="pr-rel-img"
                        />
                        <h3 className="pressrelease-card-title pr_cd_mw">
                          {item.title}
                        </h3>
                      </Link>
                      <p className="pressrelease-card-content">
                        {item.content}
                      </p>
                      <Link to={item.link} className="pressrelease-card-link">
                        Read More{" "}
                        <span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </Link>
                </div>
              ))}
            </div> */}

            <div className="row g-xl-5 g-4">
              {visiblePressReleases.map((item, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <Link to={item.link} className="pr_rel_outer">
                    <div className="pressrelease-card">
                      <Link to={item.link}>
                        <img
                          src={item.imgSrc}
                          alt={item.alt}
                          className="pr-rel-img"
                          loading="lazy"
                        />
                        <h3 className="pressrelease-card-title pr_cd_mw">
                          {item.title}
                        </h3>
                      </Link>
                      <p className="pressrelease-card-content">
                        {item.content}
                      </p>
                      <Link to={item.link} className="pressrelease-card-link">
                        Read More{" "}
                        <span>
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </Link>
                </div>
              ))}
            </div>

            {!showAll && pressReleases.length > 9 && (
              <div className="d-flex justify-content-center mt-4">
                <button
                  className="mt-2 primary-landing-main-btn re-hero-btn"
                  onClick={() => setShowAll(true)}
                >
                  <div className="re-btn-txt">Show More </div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            )}
          </div>
        </article>
      </main>

      <ServiceFooter />
    </>
  );
};

export default NewPR;
